module.exports = __webpack_public_path__ + "img/2.39609aac.png";